/**
 * In-memory access token.
 *
 * The access token used to live in localStorage, where any script on the
 * origin could read it - which defeated the point of the server keeping the
 * refresh token in an httpOnly cookie. It now lives only in module scope, and
 * is re-acquired from that cookie on page load.
 *
 * It is a 15-minute token; losing it on reload costs one refresh request.
 */
let accessToken = null;
const subscribers = new Set();

export const getAccessToken = () => accessToken;

export const setAccessToken = (token) => {
  accessToken = token || null;
  subscribers.forEach((fn) => fn(accessToken));
};

export const clearAccessToken = () => setAccessToken(null);

/** Notifies listeners (AuthContext) when the token appears or disappears. */
export const onTokenChange = (fn) => {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
};
